import React from "react";
import { Radio as RadioMUI } from "@mui/material";

import { palette } from "theme/palette";

type Props = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  value: string;
};

export const Radio = ({ onChange, checked, value }: Props) => {
  return (
    <RadioMUI
      sx={{
        color: "rgba(228, 228, 228, 1)",
        "&.Mui-checked": {
          color: palette.accent,
        },
      }}
      value={value}
      onChange={onChange}
      checked={checked}
    />
  );
};
